import { createAction } from 'typesafe-actions';

export type ErrorReason = Error | string;

export const UNHANDLED_SAGA_ERROR = createAction('errors/UNHANDLED_SAGA_ERROR')<ErrorReason>();
export const ERROR_404_NOT_FOUND = createAction('errors/404_NOT_FOUND')<ErrorReason>();
export const ERROR_500_INTERNAL_SERVER_ERROR = createAction(
  'errors/500_INTERNAL_SERVER_ERROR',
)<ErrorReason>();
